import { Layout } from '@postscript/components';
import React from 'react';
import styled from 'styled-components';

export interface ComponentLinksProps extends React.HTMLAttributes<HTMLElement> {
  figmaLink?: string;
  storybookLink?: string;
}

const StyledComponentLink = styled.a`
  display: flex;
  align-items: center;
  color: var(--text-color);
  font: var(--body-text-small);

  &:hover {
    color: var(--link-color);
    text-decoration: underline;
  }
  &:active {
    color: var(--link-color-hover);
  }

  &:focus {
    text-decoration: underline;
  }

  img {
    display: block;
    height: 18px;
    width: 18px;
    margin-right: var(--spacing-1);
  }
  strong {
    display: block;
  }
`;

const ComponentLinksContainer = styled(Layout)<ComponentLinksProps>`
  margin-top: auto;
`;

const ComponentLinks = React.forwardRef<HTMLDivElement, ComponentLinksProps>(
  ({ figmaLink, storybookLink, ...props }, ref) => {
    return (
      <ComponentLinksContainer
        gap="var(--spacing-3)"
        figmaLink={figmaLink}
        storybookLink={storybookLink}
        align="right"
        ref={ref}
        {...props}
      >
        {figmaLink && (
          <StyledComponentLink
            href={figmaLink}
            target="_blank"
            rel="noreferrer"
          >
            <img alt="View in Figma" src="img/figma-logomark.png" />
            <strong>Figma</strong>
          </StyledComponentLink>
        )}
        {storybookLink && (
          <StyledComponentLink
            href={storybookLink}
            target="_blank"
            rel="noreferrer"
          >
            <img alt="View in Storybook" src="img/storybook-logomark.svg" />
            <strong>Storybook</strong>
          </StyledComponentLink>
        )}
      </ComponentLinksContainer>
    );
  },
);

export default ComponentLinks;
